module.exports = __webpack_public_path__ + "static/img/MITCHELL-EDWARDS.d2ee969.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MITCHELL-EDWARDS.jpg
// module id = 5o0M
// module chunks = 0